/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_BOXES } from "../graphql/getBoxes.query";
import { GET_DIST_BOX } from "../graphql/getDistBox.query";
import { GET_CURRENCY_EXCHANGE_RATE } from "../graphql/getCurrencyExchangeRateProvider.query";
import appCardConfig from "../config/appCard.config.json";
import header from "../config/header.config.json";
import moment from "moment-timezone";
import { toHeaderCase } from "js-convert-case";
import { CurrencyConversion, appendExpiredItemsRemovedData } from "../../../common";
import * as changeCase from "change-case";
import toast from "react-hot-toast";
import { StorageModule } from "@vlinder-web/storage-module-react";

const is = require("is_js");
const isVideo: any = /\.(mp4|mov|avi|avchd|flv|f4v|swf|mkv|webm|html5)$/i;
const isYoutubeVideo: any =
  /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/i;

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetBoxesMethods extends IPluginMethodMap {
  getBoxes(year?: any, args?: any): Promise<any>;
}

export class GetBoxesService implements IAgentPlugin {
  readonly methods: IGetBoxesMethods;
  private exchangeRate: any = 1;

  constructor() {
    this.methods = {
      getBoxes: this.getBoxes.bind(this),
    };
  }

  async getBoxes(year?: any, args?: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageService = StorageModule.getInstance();

    try {
      if (client) {
        const res = await client.query({
          query: GET_BOXES,
          variables: {
            // filter: {
            //   Presentation___year: year.toString(),
            // },
            options: {
              sort: {
                order: "desc",
                field: "createdAt",
              },
              skip: 0,
              limit: 0,
            },
          },
          fetchPolicy: "network-only",
        });

        const _res = await client.query({
          query: GET_CURRENCY_EXCHANGE_RATE,
          fetchPolicy: "network-only",
        });

        if (_res?.data?.getCurrencyExchangeRate) {
          storageService.set(
            "currencyExchangeLocal",
            _res?.data?.getCurrencyExchangeRate,
            "local",
          );
          storageService.set(
            "currencyExchangeSession",
            _res?.data?.getCurrencyExchangeRate,
            "session",
          );
        }
        let hasDistBox = false;
        let scheduleID = null;
        try {
          const res1 = await client.query({
            query: GET_DIST_BOX,
            variables: {
              filter: {
                costumeID: res?.data?.getMyBoxes?.content[0]?.costumeID,
              },
            },
            fetchPolicy: "no-cache",
            errorPolicy: "all",
          });

          if (res1?.errors?.length) {
            hasDistBox = false;
          } else if (res1?.data?.getDistBox) {
            hasDistBox = true;
            scheduleID = res1?.data?.getDistBox?.schedule;
          }
        } catch (e) {
          hasDistBox = false;
        }
        this.exchangeRate = res?.data?.getCurrencyExchangeRate?.conversion_rate;
        let payloadArray: any = [];
        let istransferred = false;
        let groupId: string = "";
        if (
          res?.data?.getMyBoxes?.content &&
          is.not.empty(res?.data?.getMyBoxes?.content)
        ) {
          for (let obj of res?.data?.getMyBoxes?.content) {
            if (obj && is.existy(obj) && is.not.empty(obj)) {
              console.log("obj=>", obj);
              groupId = obj?.groupId ?? "";
              obj?.boxTxes.forEach((object: any) => {
                if (
                  object?.action === "pre_bookedAmount_Transferred" &&
                  obj?.presentation?.status == "active"
                ) {
                  istransferred = true;
                }
              });
            }
          }
        }

        if (
          res?.data?.getMyBoxes?.content &&
          is.not.empty(res?.data?.getMyBoxes?.content)
        ) {
          for (let obj of res?.data?.getMyBoxes?.content) {
            if (obj && is.existy(obj) && is.not.empty(obj)) {
              console.log("obj===========", obj);
              if (!obj?.isPreBooking) {
                payloadArray.push({
                  presentationStatus: obj?.presentation?.status,
                  ...this.formatData(
                    obj,
                    year,
                    res?.data?.getMyBoxes?.content,
                    scheduleID,
                  ),
                  bandCurrency: res?.data?.getCurrencyExchangeRate?.currency,
                });
              } else {
                if (!istransferred) {
                  payloadArray.push({
                    presentationStatus: obj?.presentation?.status,
                    ...this.formatData(
                      obj,
                      year,
                      res?.data?.getMyBoxes?.content,
                      scheduleID,
                    ),
                    bandCurrency: res?.data?.getCurrencyExchangeRate?.currency,
                  });
                }
              }
            }
          }
        }
        console.log("payloadArray", payloadArray);
        const filteredArray = payloadArray.filter(
          (item: any) => item.presentationStatus === "active",
        );
        const pastPurchase = this.pastPurchaseArray(
          res?.data?.getMyBoxes?.content,
        );
        console.log(filteredArray, "filteredArray");
        console.log(pastPurchase, "pastPurchase992e");
        if (filteredArray.length === 0)
          toast.error("Costume not reserved for the upcoming carnival");
        return {
          groupId,
          data: filteredArray,
          pastPurchase: pastPurchase,
          initialData: this.initialData(res?.data?.getMyBoxes?.content[0]),
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private initialData(data: any) {
    console.log(data);
    return {
      isVIP: data?.isVIP,
      isOpted: data?.delivery?.isOpted,
      deliveryOptions: header?.options,
      partner: data?.delivery?.partner,
      status: data?.delivery?.status,
      trackingId: data?.delivery?.trackingId,
      delegateName: data?.delegateName,
      cityName: data?.address?.city ?? data?.user?.mailAddress?.city,
      address:
        data?.address?.addressLine1 ??
        data?.user?.mailAddress?.addressLine1 ??
        data?.user?.address?.addressLine1,
      availableTime: data?.availableTime,
    };
  }

  private pushListItem = (
    listItems: any,
    index: number,
    title: string,
    subtitle: string,
  ) => {
    if (subtitle && is.existy(subtitle)) {
      listItems.push({
        key: index.toString(),
        icon: appCardConfig?.listItems?.icon,
        title: title,
        subtitle: subtitle,
      });
    }

    return listItems;
  };

  private getListItems = (data: any) => {
    console.log(data?.Referal);
    const invitedBy = data?.Referal?.invitedBy;
    const fullName = [invitedBy?.firstName, invitedBy?.lastName]
      .filter(Boolean)
      .join(" ");
    const label = fullName || invitedBy?.email;
    let listItems: any = [];
    let index = 0;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.sectionName,
      data?.section?.name,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.invitedBy,
      label,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.costumeID,
      data?.costumeID,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.masqID,
      data?.user?.vuid,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.paymentStatus,
      data?.paymentStats && data?.paymentStats.toLowerCase() === "unpaid"
        ? "DownPayment Due"
        : data?.paymentStats,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.totalAmount,
      `TT$ ${data?.totalAmount} / US$ ${data?.totalAmountInUSD}`,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.receivedAmount,
      `TT$ ${data?.amountPaid ?? 0} / US$ ${data?.amountPaidInUSD ?? 0}`,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.remainingAmount,
      `TT$ ${(data?.totalAmount - (data?.amountPaid ?? 0))
        .toFixed(2)
        .toString()} / US$ ${(
          data?.totalAmountInUSD - (data?.amountPaidInUSD ?? 0)
        )
          .toFixed(2)
          .toString()}`,
    );
    index++;

    this.pushListItem(
      listItems,
      index,
      appCardConfig?.listItems?.delegateName,
      data?.delegateName,
    );
    index++;

    return listItems;
  };

  private getAllSectionImages = (costumeType: any, items: any[] = []) => {
    let imagesArr: any = [];

    // 1. Add images from selected costume options (overall costumes)
    if (items && Array.isArray(items)) {
      for (let item of items) {
        const attributeImages = item?.costumeAttribute?.images;
        if (attributeImages && Array.isArray(attributeImages)) {
          for (let obj of attributeImages) {
            if (
              obj &&
              is.existy(obj) &&
              !imagesArr.some((img: any) => img.src === obj)
            ) {
              imagesArr.push({
                type:
                  isVideo.test(obj) || isYoutubeVideo.test(obj)
                    ? "video"
                    : "img",
                src: obj,
              });
            }
          }
        }
      }
    }

    // 2. Add main costume images only if no option images exist
    if (
      imagesArr.length === 0 &&
      costumeType?.images &&
      Array.isArray(costumeType?.images)
    ) {
      for (let obj of costumeType.images) {
        if (obj && is.existy(obj)) {
          if (!imagesArr.some((img: any) => img.src === obj)) {
            imagesArr.push({
              type:
                isVideo.test(obj) || isYoutubeVideo.test(obj) ? "video" : "img",
              src: obj,
            });
          }
        }
      }
    }

    return imagesArr;
  };

  private getTableData = (payload: any, data: any) => {
    if (!data) {
      return null;
    }
    console.log(data);
    let arrayItems: any = [];
    let index = 0;
    data?.map((item: any) => {
      if (item && is.existy(item) && is.not.empty(item)) {
        console.log("item============", item);
        arrayItems.push({
          key: index,
          option: item?.costumeFeature?.name ?? "-",
          desc: item?.costumeFeature?.desc,
          attribute: item?.costumeAttribute?.name ?? "-",
          value: item?.costumeValue?.name ?? "-",
          images:
            item?.costumeAttribute?.images ?? item?.costumeValue?.images ?? [],
          // cost: item?.costumeValue?.topupPrice ?? "-",
          cost: `TT$ ${item?.bookedPrice ?? item?.costumeValue?.topupPrice ?? 0
            } / TT$ ${item?.paidAmount ?? 0}`,
          // paidAmount: item?.paidAmount ?? 0,
          // bookedPrice: item?.bookedPrice ?? item?.costumeValue?.topupPrice ?? 0,
          deadline: item?.costumeValue?.deadline
            ? new Date(item.costumeValue.deadline).toLocaleDateString()
            : "-",
        });
        index++;
      }
    });

    arrayItems.push({
      key: index,
      option: "Total",
      attribute: "",
      value: "",
      images: [],
      cost: `TT$ ${payload?.totalAmount} / US$ ${CurrencyConversion(
        this.exchangeRate,
        payload?.totalAmount,
      )}`,
    });

    return {
      ...appCardConfig?.table,
      data: arrayItems,
    };
  };

  private getInvoiceData = (data: any) => {
    let arrayItems: any = [];
    let index = 0;

    const _getPaymentMode = (item: any) => {
      if (is.existy(item?.payMethod) && is.existy(item?.mode)) {
        return item?.payMethod + " / " + item?.mode;
      } else if (is.existy(item?.payMethod)) {
        return item?.payMethod;
      } else if (is.existy(item?.mode)) {
        return item?.mode;
      } else {
        return "-";
      }
    };

    data?.map((item: any) => {
      if (item && is.existy(item) && is.not.empty(item)) {
        arrayItems.push({
          key: index,
          date: moment(item?.createdAt).format("MMM D, YYYY, h:mm:ss A") ?? "",
          mode: _getPaymentMode(item),
          amount: `TT$ ${item?.amount} / US$ ${CurrencyConversion(
            this.exchangeRate,
            item?.amount,
          )}`,
          status: item?.status ?? "-",
          reason: item?.errorMessage ?? item?.resolutionStatus,
        });
        index++;
      }
    });

    arrayItems = arrayItems.sort((a: any, b: any) => {
      return new Date(b.date) - new Date(a.date);
    });

    return {
      ...appCardConfig?.invoice,
      data: arrayItems,
    };
  };

  private getJourneyChildData(item: any) {
    const data: any = [];
    let index: number = 0;

    if (
      item?.actionContent?.deliveredBy &&
      is.existy(item?.actionContent?.deliveredBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.deliveredBy,
        subTitle: item?.actionContent?.deliveredBy,
      });
    } else if (
      item?.actionContent?.purgedBy &&
      is.existy(item?.actionContent?.purgedBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.purgedBy,
        subTitle: item?.actionContent?.purgedBy,
      });
    } else if (
      item?.actionContent?.generatedBy &&
      is.existy(item?.actionContent?.generatedBy)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.generatedBy,
        subTitle: item?.actionContent?.generatedBy,
      });
    } else if (
      this.getUserName(item?.user) &&
      is.existy(this.getUserName(item?.user))
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.by,
        subTitle: this.getUserName(item?.user) ?? "",
      });
    }

    if (item?.actionContent?.currency && item?.action !== "expired-items-removed") {
      let str = "";
      if (
        item?.actionContent?.actualPayment?.currency !==
        item?.actionContent?.currency &&
        is.existy(item?.actionContent?.actualPayment?.currency) &&
        is.existy(item?.actionContent?.currency)
      ) {
        str = `US$ ${item?.actionContent?.actualPayment?.amount ?? "0.00"
          } / TT$ ${item?.actionContent?.amount ?? "0.00"}`;
      } else {
        str = `TT$ ${item?.actionContent?.amount ?? "0.00"}`;
      }

      data.push({
        key: index++,
        title: appCardConfig?.journey?.amount,
        subTitle: str,
      });
    }

    const _getReason = () => {
      if (
        is.existy(item?.reason) &&
        is.existy(item?.actionContent?.resolutionStatus)
      ) {
        return item?.reason + " / " + item?.actionContent?.resolutionStatus;
      } else if (is.existy(item?.actionContent?.resolutionStatus)) {
        return item?.actionContent?.resolutionStatus;
      } else if (is.existy(item?.reason)) {
        return item?.reason;
      }
    };

    if (_getReason() && is.existy(_getReason())) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.reason,
        subTitle: _getReason(),
      });
    }

    if (item?.action === "expired-items-removed") {
      index = appendExpiredItemsRemovedData(data, item, appCardConfig, index);
    }

    if (
      item?.actionContent?.payMethod &&
      is.existy(item?.actionContent?.payMethod)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.method,
        subTitle: item?.actionContent?.payMethod,
      });
    }

    if (item?.actionContent?.mode && is.existy(item?.actionContent?.mode)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.mode,
        subTitle: item?.actionContent?.mode,
      });
    }

    if (item?.actionContent?.status && is.existy(item?.actionContent?.status)) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.status,
        subTitle: item?.actionContent?.status,
      });
    }

    if (
      item?.actionContent?.deliveredTo &&
      is.existy(item?.actionContent?.deliveredTo)
    ) {
      data.push({
        key: index++,
        title: appCardConfig?.journey?.deliveredTo,
        subTitle: item?.actionContent?.deliveredTo,
      });
    }

    return data;
  }

  private addCollectorImage(item: any) {
    if (
      item?.actionContent?.imageUrl &&
      is.existy(item?.actionContent?.imageUrl)
    ) {
      return [
        {
          type: "img",
          src: item?.actionContent?.imageUrl,
        },
      ];
    }

    return null;
  }

  private getJourneyData = (data: any) => {
    let arrayItems: any = [];
    let index = 0;

    data &&
      data.map((item: any) => {
        if (item && is.existy(item) && is.not.empty(item)) {
          arrayItems.push({
            key: index,
            headline:
              item?.displayTitle ?? changeCase.capitalCase(item?.action),
            headlineBackgroundColor: appCardConfig?.journey?.backgroundColor,
            date: moment(item?.createdAt).format("MMMM Do YYYY, h:mm:ss a"),
            children: [
              {
                title:
                  item?.displayTitle ?? changeCase.capitalCase(item?.action),
                subtitle: moment(item?.createdAt).format("lll") ?? "",
                multiColList: {
                  numberOfColumns: "2",
                  data: this.getJourneyChildData(item),
                },
                carouselItems: this.addCollectorImage(item),
                carouselStyles: {
                  width: "140px",
                  height: "180px",
                },
              },
            ],
          });
          index++;
        }
      });

    arrayItems = arrayItems.sort((a: any, b: any) => {
      return new Date(b.date) - new Date(a.date);
    });

    return {
      ...appCardConfig?.journey,
      data: arrayItems.reverse(),
    };
  };
  private getUserName(data: any) {
    if (data?.firstName) {
      return `${toHeaderCase(data?.firstName)} ${toHeaderCase(
        data?.lastName ?? " ",
      )}`;
    }
  }

  private getButtons(
    remaining: any,
    delegateName: any,
    presentation: any,
    isDelivered: any,
    scheduleID: any,
  ) {
    console.log(remaining, delegateName, presentation, isDelivered);
    let buttonArray: any = [
      {
        key: "downloadInvoice",
        title: "Print Invoice",
      },
      // {
      //   key: "optMailDelivery",
      //   title: "Mail Delivery",
      // },
    ];
    if (presentation != "preBooking") {
      console.log(presentation);
      buttonArray.push({
        key: "changeCostumeOptions",
        title: "Change Costume Options",
      });
    }
    if (isDelivered) {
      buttonArray.push({
        key: "printDelivery",
        title: "Print Delivery Receipt",
      });
    }
    if (remaining > 0) {
      {/* enable payOnline */ }
      buttonArray.push({
        key: "payOnline",
        title: "Pay Online",
      });
    } else if (remaining == 0 && !isDelivered) {
      buttonArray.push({
        key: "bookSchedule",
        title: "Book Schedule",
      });
    }
    if (presentation != "preBooking") {
      if (delegateName === null) {
        buttonArray.push({
          key: "delegateName",
          title: "Add Delegate Name",
        });
      }
    }
    console.log(buttonArray);
    return buttonArray;
  }

  private _getCostumeValueDownPayment(items: any[]) {
    let totalDownPayment = 0;
    console.log(`items----`, items);
    if (items && Array.isArray(items)) {
      for (let i = 0; i < items.length; i++) {
        totalDownPayment += parseInt(
          items[i]?.costumeValue?.minDownPayment || 0,
        );
      }
      console.log(`totalDownPayment----`, totalDownPayment);
      return totalDownPayment;
    }
    return totalDownPayment;
  }
  private pastPurchaseArray(entireData: any) {
    const pastPurchaseArray: any = [];
    entireData.map((item: any) => {
      console.log(item),
        pastPurchaseArray.push({
          id: item?.presentation?.id,
          year: item?.presentation?.year,
          name: item?.presentation?.name,
          costumeStatus: item?.boxStatus,
          totalAmount: item?.totalAmount,
          amountPaid: item?.amountPaid,
          costumeId: item?.costumeID,
          section: item?.section?.name,
        });
    });
    console.log(pastPurchaseArray, "pastPurchaseArray");
    const pastPurchase = {
      headers: [
        "Year",
        "Presentation",
        "Action",
        "Section",
        "Costume ID",
        "Amount",
        "Costume Status",
      ],
      yearWiseDetails: pastPurchaseArray,
    };
    console.log(pastPurchase, "pastPurchase");
    return pastPurchase;
  }
  private formatData(data: any, year: any, entireData: any, scheduleID: any) {
    const d = new Date();
    let accordionItems: any = [];
    if (this.getTableData(data, data?.items)) {
      accordionItems.push(this.getTableData(data, data?.items));
    }
    console.log(accordionItems);
    if (
      data?.payOrder?.payTxes &&
      is.existy(data?.payOrder?.payTxes) &&
      is.not.empty(data?.payOrder?.payTxes)
    ) {
      console.log(year);
      accordionItems.push(this.getInvoiceData(data?.payOrder?.payTxes));
    }
    if (
      is.not.empty(
        this.getJourneyData(data?.boxTxes)?.data &&
        data?.presentation?.status === "active",
      )
    ) {
      accordionItems.push(this.getJourneyData(data?.boxTxes));
    }
    console.log(accordionItems);
    console.log("hello1", data);
    return {
      title: data?.items[0]?.costumeType?.name,
      preselectedSlotId: scheduleID,
      note:
        data?.paymentStats && data?.paymentStats.toLowerCase() === "unpaid"
          ? "You have 5 days to complete your order"
          : undefined,
      authenticated:
        data?.delivery?.status === "Delivered" ? data?.delivery?.status : null,
      subtitle: data?.items[0]?.costumeType?.description,
      costumeTypeMinDownPayment:
        data?.items[0]?.costumeType?.minDownPayment ?? 0,
      costumeValueMinDownPayment: this._getCostumeValueDownPayment(data?.items),
      listItems: this.getListItems(data),
      carouselItems: this.getAllSectionImages(
        data?.items[0]?.costumeType,
        data?.items,
      ),
      buttons:
        data?.presentation?.status === "active"
          ? this.getButtons(
            data?.totalAmount - (data?.amountPaid ?? 0),
            data?.delegateName,
            data?.presentation?.type,
            data?.delivery?.status,
            scheduleID,
          )
          : [],
      accordionItems: accordionItems,
      paidAmount: data?.amountPaid ?? 0,
      totalAmount: data?.totalAmount,
      remainingAmount: data?.totalAmount - (data?.amountPaid ?? 0),
      userName: this.getUserName(data?.user) ?? "",
      userEmail: data?.user?.email ?? "",
      payOrderID: data?.payOrder?.id,
      currencyExchangeRate: this.exchangeRate,
      costumeID: data?.costumeID,
      boxId: data?.id,
      data: data,
    };
  }
}
